import React, { useState } from "react";
import InputIcon from "./functional/input-icon";
import styles from "./game-score.module.css";
import { useTranslation } from "react-i18next";
import { Check } from "lucide-react";

const GameScore = ({ submitScore }) => {
  const [currentTeamScore, setCurrentTeamScore] = useState(0);
  const [opponentTeamScore, setOpponentTeamScore] = useState(0);
  const { t } = useTranslation();
  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <h1 className="title-3">{t("dashboard.game-score.title")}</h1>
        <p className="subtitle-2">{t("dashboard.game-score.subtitle")}</p>
      </div>
      <div className={styles.content}>
        <div className={styles.inputs}>
          <InputIcon
            icon="logos/first-team.png"
            min={0}
            max={50}
            placeholder="0"
            title={t("dashboard.game-score.your-score")}
            onChange={(e) => setCurrentTeamScore(e.value)}
          />
          <p className="title-2-variant">:</p>
          <InputIcon
            icon="logos/second-team.png"
            min={0}
            max={50}
            placeholder="0"
            title={t("dashboard.game-score.opponent-score")}
            onChange={(e) => setOpponentTeamScore(e.value)}
          />
        </div>
        <div>
          <button
            className="btn btn--primary btn--icon-only"
            onClick={() => submitScore(currentTeamScore, opponentTeamScore)}
          >
            <Check size={20} className="icon" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default GameScore;
